import React from "react";

import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Stack } from "@mui/material";

import { useTheme } from "@fartherfinance/frontend/theme/ThemeProvider";

import styles from "./BorderedList.module.css";

export interface Props {
  headers?: {
    left: React.ReactNode;
    right?: React.ReactNode;
    rowStyle?: React.CSSProperties;
  }[];
  rows: {
    left: React.ReactNode;
    right?: React.ReactNode;
    rowStyle?: React.CSSProperties;
  }[];
  maxHeight?: number;
}

const BorderedList = (props: Props): JSX.Element => {
  return (
    <div className={styles.container}>
      {(props.headers ?? []).map((r, i) => {
        return (
          <div key={`${i}`} className={styles.row} style={r.rowStyle}>
            <div>{r.left}</div>
            <div>{r.right}</div>
          </div>
        );
      })}

      <div
        className={styles.rows}
        style={props.maxHeight ? { maxHeight: `${props.maxHeight}px` } : {}}
      >
        {props.rows.map((r, i) => {
          return (
            <div key={`${i}`} className={styles.row} style={r.rowStyle}>
              <div>{r.left}</div>
              <div>{r.right}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BorderedList;

type BorderedRowProps = {
  left: React.ReactNode;
  right: React.ReactNode;
  middle?: React.ReactNode;
  onClick?: () => void;
  removeBorderBottom?: boolean;
};

export const BorderedRow: React.FC<BorderedRowProps> = ({
  left,
  middle,
  right,
  onClick,
  removeBorderBottom,
}): JSX.Element => {
  const {
    color: { $iconSubtle, $borderBold },
  } = useTheme();
  return (
    <div
      className={styles.row}
      onClick={onClick}
      style={{
        cursor: onClick !== undefined ? "pointer" : "default",
        borderBottom:
          removeBorderBottom == true ? "none" : `1px solid ${$borderBold}`,
      }}
    >
      <div>{left}</div>
      <div>{middle}</div>
      <Stack direction="row" spacing={1}>
        <div>{right}</div>
        {onClick !== undefined ? (
          <ChevronRightIcon
            style={{
              color: $iconSubtle,
              width: "18px",
              height: "18px",
            }}
          />
        ) : null}
      </Stack>
    </div>
  );
};
